import React from "react"
import { TimeBar, Wrapper } from "./styled"

const Timer = () => (
  <Wrapper>
    <TimeBar />
  </Wrapper>
)

export default Timer